"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var ModalV2_1 = __importDefault(require("@src/components/ModalV2"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
require("./LoaderModal.scss");
var defaults = {
    closeModal: function () { return null; },
    title: '',
    subTitle: 'This might take a few seconds...',
    closeable: false,
};
var LoaderModal = function (_a) {
    var modalActive = _a.modalActive, closeModal = _a.closeModal, title = _a.title, subTitle = _a.subTitle, closeable = _a.closeable;
    return (react_1["default"].createElement(ModalV2_1["default"], { title: "", subtitle: "", headerIcon: null, headerSubIcon: null, active: modalActive, classPrefix: "loader-modal" + (!closeable ? '-static' : ''), isV2: true, toggleModal: function () { return closeable && closeModal(); } },
        react_1["default"].createElement(loader_1["default"], { prefixClassName: "loader", size: 40 }),
        react_1["default"].createElement(text_1["default"], { className: "loader-title", marginBottom: 20, variant: "h2.semi-bold" }, title),
        react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.deep" }, subTitle)));
};
LoaderModal.defaultProps = defaults;
function areEqual(prevProps, nextProps) {
    if (prevProps.modalActive !== nextProps.modalActive)
        return false;
    if (prevProps.title !== nextProps.title)
        return false;
    if (prevProps.subTitle !== nextProps.subTitle)
        return false;
    if (prevProps.closeable !== nextProps.closeable)
        return false;
    return true;
}
exports["default"] = react_1["default"].memo(LoaderModal, areEqual);
